import styled, { css } from 'styled-components';

export const TableHeadCell = styled.th`
  ${(props) =>
    props.width &&
    css`
      max-width: ${(props) => (props.width === 'auto' ? 'none' : props.width + 'px')};
      ${props.$resized &&
      props.width !== 'auto' &&
      css`
        width: ${props.width}px;
        min-width: ${props.width}px;
      `}
    `}
  text-align: ${(props) => (props.$numeric || props.align === 'right' ? 'end' : 'start')};
  padding-right: ${(props) => (props.$numeric ? '35px' : '0')};
  ${(props) =>
    props.align === 'right' &&
    css`
      padding-right: 0;
    `}
  ${(props) =>
    props.$resizable &&
    css`
      padding-right: 24px;
    `}

  position: relative;
  border-bottom: 1px solid #929292;
  height: 35px;
  font-size: 15px;
  opacity: 1;
  &:nth-child(1) {
    padding-left: 20px;
  }

  ${(props) =>
    props.withSort &&
    css`
      pointer-events: auto;
      &:hover {
        font-weight: bold;
        opacity: 1;
      }
      & > div:not([data-resize-handle]) {
        cursor: pointer;
        p {
          display: inline-block;
          margin-right: 10px;
        }
      }
    `}

  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      color: #b7babf;
      opacity: 1;
      border-bottom: 1px solid #6c7277;
    `}

  & > div:not([data-resize-handle]) {
    display: flex;
    align-items: center;
    max-width: 100%;
    overflow: hidden;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ${(props) =>
      props.align === 'right' &&
      css`
        justify-content: center;
      `}
  }

  input[type='checkbox'] {
    cursor: pointer;
    width: 17px;
    height: 17px;
    /* font-size: 20px;
    line-height: 1;
    padding: 5px; */
  }
`;

export const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: 2px;
  width: 18px;
  height: 100%;
  cursor: col-resize;
  z-index: 5;
  user-select: none;
  touch-action: none;
  display: flex;
  justify-content: center;

  &::after {
    content: '';
    width: 2px;
    height: 100%;
    border-radius: 1px;
    background: #dcdde0;
    transition: background 0.15s ease-in, width 0.15s ease-in;
  }

  &:hover::after,
  &:active::after {
    width: 4px;
    background: #3f8cff;
  }

  &:active::after {
    background: #1867d6;
  }
`;
